import { cn } from '@sola/ark-core/utils/helpers.js';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.js';

import { CommitmentAvatar } from '../../atoms/commitment-avatar/commitment-avatar';
import { CommitmentCountTooltip } from '../../atoms/commitment-count-tooltip/commitment-count-tooltip';

interface CommitmentsBadgesProps {
  commitments: GraphQLCommitment[];
  layout?: 'spaced' | 'stacked';
  itemsToShow?: number;
}

export const CommitmentsBadges = ({
  commitments,
  layout = 'stacked',
  itemsToShow = 3,
}: CommitmentsBadgesProps) => {
  return (
    <div
      className={cn({
        'flex flex-row gap-comfy-xs': layout === 'spaced',
        'flex items-center gap-snug-md': layout === 'stacked',
      })}
    >
      <div className="flex flex-row gap-snug-xl">
        {commitments.slice(0, itemsToShow).map((commitment, index) => {
          const shouldShowRemaining =
            index === itemsToShow - 1 && commitments.length > itemsToShow;
          /** NOTE: plus one to account for this item plus remaining */
          const remainingCount = commitments.length - itemsToShow + 1;

          return (
            <div
              key={commitment.id}
              className={cn({
                '-ml-comfy-md': layout === 'stacked',
              })}
            >
              <CommitmentAvatar
                {...(!shouldShowRemaining
                  ? { commitment }
                  : { text: `+${remainingCount}` })}
                isStacked={layout === 'stacked'}
              />
            </div>
          );
        })}
      </div>

      <CommitmentCountTooltip count={commitments.length} />
    </div>
  );
};
